<template>
    <div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import { VueReCaptcha } from 'vue-recaptcha-v3'
    import $ from "jquery";

    const GoogleReCAPTCHASiteKey = !window.siteSettingsConfig ? '' : window.siteSettingsConfig.googleReCAPTCHASiteKey;

    Vue.use(VueReCaptcha, { siteKey: GoogleReCAPTCHASiteKey });

    export default {
        name: "GReCaptchaValidation",
        data: function () {
            return {
                reCaptchaLoaded: false,
                attemptedSubmit: false
            };
        },
        mounted: function () {
            var $form = $(this.$el)
                .closest("form");

            $form.submit(this.onFormSubmit);

            this.recaptcha();
        },
        updated: function () {
            this.reCaptchaLoaded = false;
        },
        methods: {
            onFormSubmit($event) {
                this.attemptedSubmit = true;
                if (!this.reCaptchaLoaded) {
                    $event.preventDefault();
                }
            },
            async recaptcha() {
                // (optional) Wait until recaptcha has been loaded.
                await this.$recaptchaLoaded()

                var $form = $(this.$el)
                    .closest("form");

                var actionName = $form.find("input[name*='.ActionName']").val();

                // Execute reCAPTCHA with action.
                const token = await this.$recaptcha(actionName);

                if (!token) {
                    return;
                }

                this.reCaptchaLoaded = true;

                $form.find("input[name*='.Token']").val(token);

                if (this.attemptedSubmit) {
                    this.attemptedSubmit = false;
                    $form.submit();
                }               
            }
        }
    }
</script>